import { render, staticRenderFns } from "./ScreenSizeAlert.vue?vue&type=template&id=9007439a&"
import script from "./ScreenSizeAlert.vue?vue&type=script&lang=js&"
export * from "./ScreenSizeAlert.vue?vue&type=script&lang=js&"
import style0 from "./ScreenSizeAlert.vue?vue&type=style&index=0&id=9007439a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports